
<div class="flow-pagination-container" :position="position">
	<Icon
		name="i-chevron-left"
		type="filled"
		state="dark"
		size="small"
		:disabled="offset <= 0 || loading"
		@click="prev()"
	/>
	<p v-if="!loading" class="paragraph-1 fc-normal">
		{{ label }}
	</p>
	<Icon v-if="loading" size="small" name="loading" />
	<p v-if="loading" class="paragraph-1 fc-normal loading-text">Loading...</p>
	<Icon
		name="i-chevron-right"
		type="filled"
		state="dark"
		size="small"
		:disabled="offset + max >= total || loading"
		@click="next()"
	/>
</div>
